import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { useTheme } from '@mui/material';
import { useAtomValue } from 'jotai/index';
import { CSSProperties } from 'react';
import { useCurrentUser } from '../../services/hooks/useCurrentUser';
import { usersAtom } from '../../services/state/AppConfigStateJ';
import { AvatarSize, MUIAvatar } from './MUIAvatar';

export interface AvatarProps {
  size: AvatarSize;
  style?: CSSProperties;
}

export function CurrentUserAvatar({ size, style }: AvatarProps) {
  const currentUser = useCurrentUser();
  const { primary } = useTheme().colors;
  const users = useAtomValue(usersAtom);

  const iconSize = getIconSize(size);

  if (!currentUser || !users?.length) {
    return <NoAccountsIcon aria-label='unknown user' fontSize={iconSize} htmlColor={primary[20]} />;
  }

  return (
    <MUIAvatar
      size={iconSize}
      src={null}
      nameParts={[currentUser.firstName ?? '', currentUser.lastName ?? '']}
      style={style}
    />
  );
}

function getIconSize(size: AvatarProps['size']): 'small' | 'medium' | 'large' {
  if (size === 'mediumLarge' || size === 'gridCell') {
    return 'medium';
  }
  // `fontSize` on the fallback icon has no step above `large`.
  return size === 'xlarge' ? 'large' : size;
}
